<!-- The onboarding handoff into My Day (B-11; D17, OB-H-01, OB-H-04). Decorative only: the layer is aria-hidden and
     holds no text or control. Drawn only while a handoff shows (never under reduced motion: an instant switch). Every
     value is precomputed (handoff.logic.ts buildHandoffOverlayVm); the template holds no logic. -->
<ng-container *ngIf="view$ | async as view">
    <div
        *ngIf="view.isShown"
        class="vf-onboarding-handoff"
        [class.vf-onboarding-handoff--blocking]="view.isBlocking"
        [class.vf-onboarding-handoff--rail-gone]="view.isRailGone"
        [class.vf-onboarding-handoff--revealing]="view.isRevealing"
        [ngStyle]="view.timing"
        aria-hidden="true"
    >
        <!-- The dark stage's field, as Organize left it; its cards then line up into rows. -->
        <vf-dark-entry-field
            class="vf-onboarding-handoff__field"
            [progress]="view.fieldProgress"
            [layout]="view.fieldLayout"
        ></vf-dark-entry-field>

        <!-- The rail as Organize left it (every chapter done), then it fades. -->
        <div class="vf-onboarding-handoff__rail">
            <img class="vf-onboarding-handoff__logo" [src]="view.logoUrl" alt="" />
            <div class="vf-onboarding-handoff__progress">
                <span class="vf-onboarding-handoff__ring">
                    <svg class="vf-onboarding-handoff__check" viewBox="0 0 24 24" focusable="false">
                        <path d="M20 6 9 17l-5-5"></path>
                    </svg>
                </span>
                <span class="vf-onboarding-handoff__heading"></span>
            </div>
            <div class="vf-onboarding-handoff__items">
                <span
                    *ngFor="let item of view.railItems; trackBy: trackRailItem"
                    class="vf-onboarding-handoff__item"
                >
                    <span class="vf-onboarding-handoff__dot"></span>
                    <span class="vf-onboarding-handoff__name"></span>
                </span>
            </div>
        </div>
    </div>
</ng-container>
